@if (spinner) {
  <div class="spinner">
    <ng-lottie [options]="lottieOptions"></ng-lottie>
  </div>
}
<br>
  <div [ngClass]="{'disable-readonly': readOnly}" [hidden]="question?.group_type!=group || question?.cent_aq_question_type_id!=3"
    class="form-group form-group--lg question question-{{question?.group_type}}">
    <label [innerHtml]="question?.email_version"></label>
    <div class="form-control__wrap has-clear has-marker">
      <input type="search" readonly value="{{question?.answer}}" placeholder="Start typing address" id="pac-input"
        autocomplete="off" class="form-control" data-place="" #search/>
        <span class="form-control__marker">
          <svg class="icon"><use xlink:href="#location"></use></svg>
        </span>
        <a href="#" id="clear-address" class="form-control__clear">
          <svg class="icon">
            <use xlink:href="#close-circle-small"></use>
          </svg>
        </a>
      </div>
      <br>
        <div class="spinner">
          <ng-lottie [options]="lottieOptions"></ng-lottie>
        </div>
        <google-map height="160px" width="100%" [zoom]="zoom" [center]="center"
          [hidden]="question?.group_type!='details' || question?.cent_aq_question_type_id!=3"
          [options]="options">
          <map-marker [position]="marker.position" [label]="marker.label" [title]="marker.title"
            [options]="marker.options">
          </map-marker>
        </google-map>

      </div>

      @if (!checkDisabledQuestions(question?.question_id) && question?.cent_aq_question_type_id==2) {
        <div
          [ngClass]="{'disable-readonly': readOnly}"
          class="form-group form-group--lg question question-{{question?.group_type}}">
          <label [innerHtml]="question?.email_version"></label>
          <input id="{{question?.question_id}}" [(ngModel)]="question.answer" (blur)="saveAnswer()" type="text"
            value="{{question?.answer}}" class="form-control answers"/>
          </div>
        }

        @if ((question?.cent_aq_question_type_id==2 || question?.cent_aq_question_type_id==73|| question?.cent_aq_question_type_id==74 || question?.cent_aq_question_type_id==75) && checkDisabledQuestions(question?.question_id)) {
          <div
            [ngClass]="{'disable-readonly': readOnly}"
            class="form-group form-group--lg question question-{{question?.group_type}}">
            <label [innerHtml]="question?.email_version"></label>
            <div class="input-group">
              <input type="text" disabled value="{{question?.answer}}" placeholder="Placeholder" class="form-control">
              <div class="input-group-append">
                <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
                  data-trigger="focus" data-html="true" data-placement="bottom"
                  data-content="To change this answer you need to restart or contact us">
                  <svg class="icon">
                    <use xlink:href="#info"></use>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        }

        @if (question?.cent_aq_question_type_id==4) {
          <div
            [ngClass]="{'disable-readonly': readOnly}"
            class="form-group form-group--lg question question-{{question?.group_type}}">
            <label [innerHtml]="question?.email_version"></label>
            <div class="custom-step">
              <div class="custom-step__control custom-step__control--dsc" (click)="setStep(-1, question)">
                <svg class="icon">
                  <use xlink:href="#minus"></use>
                </svg>
              </div>
              <input class="form-control currency" readonly value="{{question?.answer}}"/>
              <div class="custom-step__control custom-step__control--asc" (click)="setStep(1, question)">
                <svg class="icon">
                  <use xlink:href="#plus"></use>
                </svg>
              </div>
            </div>
          </div>
        }

        @if (question?.cent_aq_question_type_id==7 && question?.options.indexOf('Yes') >= 0 && question?.question_id!=576 && question?.group_type==group) {
          <div [ngClass]="{'disable-readonly': readOnly}"
            class="form-group form-group--lg question question-{{question?.group_type}}">
            <label [innerHtml]="question?.email_version"></label>
            <div class="row row--sm">
              <div class="col-sm mt-15 mt-sm-0">
                <label class="custom-input custom-input--radio custom-input--pill">
                  @if (question?.answer.indexOf('Yes') >= 0) {
                    <input type="radio" [attr.question-id]="question?.question_id"
                      [attr.data-answer-id]="question?.cent_aq_answer_id"
                      data-answer="Yes" (click)="checkRadio('Yes')" checked name="radio-col-{{question?.question_id}}[]"/>
                  }
                  @if (question?.answer.indexOf('No') >= 0) {
                    <input type="radio" [attr.question-id]="question?.question_id"
                      [attr.data-answer-id]="question?.cent_aq_answer_id"
                      data-answer="Yes" (click)="checkRadio('Yes')" name="radio-col-{{question?.question_id}}[]"/>
                  }
                  <span class="custom-input__indi"></span> <span class="custom-input__label">Yes</span>
                </label>
              </div>
              <div class="col-sm mt-15 mt-sm-0">
                <label class="custom-input custom-input--radio custom-input--pill">
                  @if (question?.answer.indexOf('No') >= 0) {
                    <input type="radio" [attr.question-id]="question?.question_id"
                      data-answer="No"
                      (click)="checkRadio('No')" checked name="radio-col-{{question?.question_id}}[]">
                  }
                  @if (question?.answer.indexOf('Yes') >= 0) {
                    <input type="radio" [attr.question-id]="question?.question_id"
                      data-answer="No"
                      (click)="checkRadio('No')" name="radio-col-{{question?.question_id}}[]">
                  }
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">No</span>
                </label>
              </div>
            </div>
          </div>
        }

        @if (question?.cent_aq_question_type_id==7 && question?.question_id==576 && question?.group_type==group) {
          <div [ngClass]="{'disable-readonly': readOnly}"
            class="form-group form-group--lg question question-{{question?.group_type}}">
            <label [innerHtml]="question?.email_version"></label>
            @for (option of getOptions(); track trackByFn(i, option); let i = $index) {
              <label class="custom-input custom-input--radio custom-input--pill"
                >
                @if (option?.answer==question?.answer) {
                  <input checked type="radio" (click)="checkRadio(option?.answer)"
                    [attr.data-answer]="option?.answer" name="radio-{{question?.question_id}}[]"/>
                }
                @if (option?.answer!=question?.answer) {
                  <input type="radio" (click)="checkRadio(option?.answer)"
                    [attr.data-answer]="option?.answer" name="radio-{{question?.question_id}}[]"/>
                }
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">{{option?.answer}}</span>
              </label>
            }
          </div>
        }

        @if (question?.cent_aq_question_type_id==7 && question?.options.indexOf('Yes') == -1 && question?.group_type==group) {
          <div [ngClass]="{'disable-readonly': readOnly}"
            class="form-group form-group--lg question question-{{question?.group_type}}">
            <label [innerHtml]="question?.email_version"></label>
            @for (option of getOptions(); track trackByFn(i, option); let i = $index) {
              <label class="custom-input custom-input--radio custom-input--pill"
                >
                @if (option?.answer == question?.answer) {
                  <input type="radio" checked (click)="checkRadio(option?.answer)"
                    [attr.data-answer]="option?.answer" name="radio-{{question?.question_id}}[]"/>
                }
                @if (option?.answer != question?.answer) {
                  <input type="radio" (click)="checkRadio(option?.answer)"
                    [attr.data-answer]="option?.answer" name="radio-{{question?.question_id}}[]"/>
                }
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">{{option?.answer}}</span>
              </label>
            }
          </div>
        }

        <!-- <div [ngClass]="{'disable-readonly': readOnly}" *ngIf="question?.cent_aq_question_type_id==7 && checkDisabledQuestions(question?.question_id) && question?.group_type==group" class="form-group form-group--lg question question-{{question?.group_type}}">
        <label [innerHtml]="question?.email_version"></label>
        <div class="input-group">
          <input type="text" disabled value="{{question?.answer}}" placeholder="Placeholder" class="form-control">
          <div class="input-group-append">
            <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover" data-trigger="focus" data-html="true" data-placement="bottom" data-content="To change this answer you need to restart or contact us">
              <svg class="icon"><use xlink:href="#info"></use></svg>
            </a>
          </div>
        </div>

      </div> -->


      @if (question?.cent_aq_question_type_id==19 && !checkDisabledQuestions(question?.question_id) && question?.group_type==group) {
        <div [ngClass]="{'disable-readonly': readOnly}"
          class="form-group form-group--lg question question-{{question?.group_type}}">
          <label [innerHtml]="question?.email_version"></label>
          <select id="dropdown-{{question?.index}}" class="ui-selectmenu">
            @for (option of getOptions(); track trackByFn(i, option); let i = $index) {
              <option value="{{option?.answer}}">
                {{option?.answer}}
              </option>
            }
          </select>
        </div>
      }

      @if (question?.cent_aq_question_type_id==19 && checkDisabledQuestions(question?.question_id) && question?.group_type==group) {
        <div [ngClass]="{'disable-readonly': readOnly}"
          class="form-group form-group--lg question question-{{question?.group_type}}">
          <label [innerHtml]="question?.email_version"></label>
          <div class="input-group">
            <input type="text" disabled value="{{question?.answer}}" placeholder="Placeholder" class="form-control">
            <div class="input-group-append">
              <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
                data-trigger="focus" data-html="true" data-placement="bottom"
                data-content="To change this answer you need to restart or contact us">
                <svg class="icon">
                  <use xlink:href="#info"></use>
                </svg>
              </a>
            </div>
          </div>
        </div>
      }

      @if (question?.cent_aq_question_type_id==37 && question?.group_type==group) {
        <div [ngClass]="{'disable-readonly': readOnly}"
          class="form-group form-group--lg question question-{{question?.group_type}}">
          <label [innerHtml]="question?.email_version"></label>
          <div class="form-group form-group--lg">
            <div id="beneficiaries-accordion">
              <div class="card card--form">
                <a href="#allrisk" class="card-title" data-toggle="collapse" aria-expanded="true">
                  <div class="card-title__text">
                    <h4>{{getDescriptionIndex(item?.description_1, 2)}}</h4>
                  </div>
                  <div class="card-title__caret">
                    <svg class="icon">
                      <use xlink:href="#dropdown"></use>
                    </svg>
                  </div>
                </a>
                <div class="card-body collapse show" id="allrisk" data-parent="#beneficiaries-accordion">
                  <div class="card__content">
                    <div class="form-group form-group--sm ui-front">
                      <label for="select-7">Category</label>
                      <select class="ui-selectmenu" id="category">
                        @for (option of getOptions(); track trackByFn(i, option); let i = $index) {
                          <option (click)="checkAllrisk()"
                            [selected]="option?.answer==getDescriptionIndex(item?.description_1,0)?'true':''"
                            value="{{option?.answer}}">
                            {{option?.answer}}
                          </option>
                        }
                      </select>
                    </div>
                    <div class="form-group form-group--sm">
                      <label>Description</label>
                      <input type="text" id="description" (blur)="checkAllrisk();"
                        value="{{getDescriptionIndex(item?.description_1,1)}}" class="form-control">
                      </div>
                      <div class="form-group form-group--sm">
                        <label>Amount</label>
                        <input type="text" id="amount" readonly value="{{accounting?.formatMoney(item?.benefit_value)}}"
                          class="form-control">
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /card -->
                </div>
              </div>
            </div>
          }

          <!-- <div [ngClass]="{'disable-readonly': readOnly}" *ngIf="question?.cent_aq_question_type_id==39 && checkDisabledQuestions(question?.question_id) && question?.group_type==group"
          class="form-group form-group--lg question question-{{question?.group_type}}">
          <label [innerHtml]="question?.email_version"></label>
          <div class="input-group">
            <input type="text" disabled value="{{question?.answer}}" placeholder="Placeholder" class="form-control">
            <div class="input-group-append">
              <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
                data-trigger="focus" data-html="true" data-placement="bottom"
                data-content="To change this answer you need to restart or contact us">
                <svg class="icon">
                  <use xlink:href="#info"></use>
                </svg>
              </a>
            </div>
          </div>

        </div> -->

        @if (question?.cent_aq_question_type_id==39 && question?.group_type==group) {
          <div [ngClass]="{'disable-readonly': readOnly}"
            class="form-group form-group--lg question question-{{question?.group_type}}">
            <label [innerHtml]="question?.email_version"></label>
            <div class="custom-number">
              @for (option of getButtonOptions(); track trackByFn(i, option); let i = $index) {
                <label class="custom-number__number">
                  @if (option?.answer==question?.answer) {
                    <input type="radio" (click)="checkRadio(option?.answer)" checked
                      name="numbers-{{question?.question_id}}[]">
                  }
                  @if (option?.answer!=question?.answer) {
                    <input type="radio" [disabled]="option?.active==0"
                      (click)="checkRadio(option?.answer)" name="numbers-{{question?.question_id}}[]">
                  }
                  <span class="custom-number__label">{{option?.answer}}</span>
                </label>
              }
            </div>
          </div>
        }

        @if (question?.cent_aq_question_type_id==49 && checkDisabledQuestions(question?.question_id) && question?.group_type==group) {
          <div [ngClass]="{'disable-readonly': readOnly}"
            class="form-group form-group--lg question question-{{question?.group_type}}">
            <label [innerHtml]="question?.email_version"></label>
            <div class="input-group">
              <input type="text" disabled value="{{question?.answer}}" placeholder="Placeholder" class="form-control">
              <div class="input-group-append">
                <a class="input-group-icon popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
                  data-trigger="focus" data-html="true" data-placement="bottom"
                  data-content="To change this answer you need to restart or contact us">
                  <svg class="icon">
                    <use xlink:href="#info"></use>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        }
        @if (question?.cent_aq_question_type_id==49 && !checkDisabledQuestions(question?.question_id) && question?.group_type==group) {
          <div [ngClass]="{'disable-readonly': readOnly}"
            class="form-group form-group--lg question question-{{question?.group_type}}">
            <label [innerHtml]="question?.email_version"></label>
            @for (option of getOptions(); track trackByFn(i, option); let i = $index) {
              <label class="custom-input custom-input--checkbox custom-input--pill"
                >
                @if (option?.answer=='None of the above') {
                  <input type="checkbox" data-type="exclusive" class="multiselect"
                    value="{{option?.answer}}" (click)="checkMultiSelect()" name="checkbox-{{option?.cent_aq_answer_id}}"/>
                }
                @if (question?.answer.indexOf(option?.answer)>=0 && option?.answer!='None of the above') {
                  <input type="checkbox"
                    checked class="multiselect" value="{{option?.answer}}" (click)="checkMultiSelect()"
                    name="checkbox-{{option?.cent_aq_answer_id}}"/>
                }
                @if (question?.answer.indexOf(option?.answer)==-1 && option?.answer!='None of the above') {
                  <input type="checkbox"
                    class="multiselect" value="{{option?.answer}}" (click)="checkMultiSelect()"
                    name="checkbox-{{option?.cent_aq_answer_id}}"/>
                }
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">{{option?.answer}}</span>
              </label>
            }
          </div>
        }
        <!-- <div *ngIf="question?.cent_aq_question_type_id==78 && item?.benefit_value" class="form-group form-group--sm question" id="insured">
        <label>Adjusted Sum Insured</label>
        <app-slider
          [question]="question"
          [item]="item"
          [sliderStep]="100"
          [sliderMin]="question?.val_min"
          [sliderMax]="question?.val_max"
          [sliderInit]="item?.benefit_value"
          [type]="'suminsured'"
          (slideUpdate)=saveSliderValue($event)>
        </app-slider>

      </div>
      <div *ngIf="question?.cent_aq_question_type_id==79 || question?.cent_aq_question_type_id==37 && question?.group_type==group" class="form-group form-group--lg question question-{{question?.group_type}}">
        <label>{{question?.email_version}}</label>
        <app-slider
          [question]="question"
          [item]="item"
          [sliderStep]="10"
          [sliderMin]="question?.excess_min"
          [sliderMax]="question?.excess_max"
          [sliderInit]="question?.answer"
          (slideUpdate)=saveSliderValue($event)>
        </app-slider>

      </div> -->
      @if (question?.cent_aq_question_type_id==78 && question?.group_type==group) {
        <div [ngClass]="{'disable-readonly': readOnly}"
          class="form-group form-group--lg question question-{{question?.group_type}}">
          <label [innerHtml]="question?.email_version"></label>
          <app-slider
            [question]="question"
            [item]="item"
            [sliderStep]="10"
            [sliderMin]="question?.val_min"
            [sliderMax]="question?.val_max"
            [sliderInit]="question?.answer"
            [type]="group"
            (slideUpdate)=saveSliderValue($event)>
          </app-slider>
        </div>
      }

      <div class="modal fade modal--alert" id="modal-additional" tabindex="-1" role="dialog"
        aria-labelledby="modal-additional-qs-1" aria-modal="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content modal-alert modal-alert--alt">

            <div class="modal-alert__heading">
              <div class="container">
                <div class="modal-alert__avatar">
                  <img src="assets/{{policy?.product_category_id}}/avatar/happy.png" class="img-fluid" alt="">
                </div>
                <button class="modal-alert__close" data-dismiss="modal">
                  <svg class="icon">
                    <use xlink:href="#close-medium"></use>
                  </svg>
                </button>
              </div>
            </div>

            <div class="modal-alert__content">
              <div class="container">
                <div class="rte">
                  <h3>Changing this answer may require additional questions.</h3>
                  <p>Note that changes may affect your premium. All previously answered questions that don’t require changes
                  will still be saved.</p>
                </div>
              </div>

            </div>


            <div class="modal-alert__button">
              <div class="container">
                <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
                <a href="#" class="button button--lg button--primary" (click)="startFlow()" data-toggle="modal"
                data-dismiss="modal">Got it</a>
              </div>
            </div>
          </div>
        </div>
      </div>









